export default function formErrors($form_container, errors)
{
    var input_name;
    for(input_name in errors)
    {

        var $input = $form_container.find('[name="' + input_name + '"]');

        // TODO: Get the prefix from somewhere
        if ($input.length == 0)
            $input = $form_container.find('[name="popup_' + input_name + '"]');


        if ($input.length > 0)
        {
            // Handle error stuff
            var $errorMessage = $('<div>').addClass('invalid-feedback').html(errors[input_name][0]);

            if ($input.hasClass('selectpicker'))
            {
                $input = $input.parents('.form-control').first();
            }

            var $currentFeedback = $input.next('div.invalid-feedback');
            if ($currentFeedback.length > 0) $currentFeedback.remove();

            $input.addClass('is-invalid');
            $input.after($errorMessage);
        }
    }
}